const ELineupType = Object.freeze({
  HOME: 'home',
  AWAY: 'away',
  PRACTICE: 'practice',
});

export { ELineupType };
